$(function () {

    let container = $('#chatBoxFrameContainer');

    if (!container.length) {
        return;
    }

    container.on('shown.bs.collapse', function () {
        let self = $(this);

        self.height(self.width());
    });

});
